import React, { useState, useEffect } from 'react';
import { Form, FormSpy } from 'react-final-form';
import { Config } from 'final-form';

import { FormValues } from './questions';

export interface Props {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
  onChange: (values: FormValues) => void;
}

export const Page: React.FC<{}> = ({ children }) => <>{children}</>;

export const Wizard: React.FC<Props> = (props) => {
  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
    })();
  }, [page]);

  const children = React.Children.toArray(props.children);
  const activePage = children[page];
  const pageCount = children.length;
  const isLastPage = page === pageCount - 1;
  const percentDone = (page / pageCount) * 100;

  return (
    <section className="section">
      <Form
        initialValues={props.initialValues}
        validate={(values) => {
          const pageWithValidate = activePage as { props?: { validate: Config<Record<string, any>>['validate'] } };
          if (pageWithValidate.props?.validate) {
            return pageWithValidate.props.validate(values);
          }
          return {};
        }}
        onSubmit={(values) => {
          if (isLastPage) {
            return props.onSubmit(values);
          } else {
            setPage(Math.min(page + 1, pageCount - 1));
          }
        }}
      >
        {({ handleSubmit, submitting, values }) => (
          <div className="container">
            <FormSpy subscription={{ values: true }} onChange={(state) => props.onChange(state.values as FormValues)} />
            <form onSubmit={handleSubmit}>
              <progress className="progress is-primary" value={percentDone} max="100">
                {percentDone}%
              </progress>
              {activePage}
              <div className="columns mt-4 is-centered is-mobile">
                {page > 0 && (
                  <div className="column has-text-left">
                    <button className="button" type="button" onClick={() => setPage(Math.max(page - 1, 0))}>
                      « Edellinen
                    </button>
                  </div>
                )}
                {!isLastPage && (
                  <div className="column has-text-right">
                    <button className="button" type="submit" onClick={() => window.scrollTo(0, 0)}>
                      Seuraava »
                    </button>
                  </div>
                )}
                {isLastPage && (
                  <div className="column has-text-right">
                    <button className="button is-success" type="submit" disabled={submitting}>
                      Lähetä
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        )}
      </Form>
    </section>
  );
};
